var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveRow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8634 14 14 10.8634 14 7C14 3.13659 10.8634 0 7 0C3.13659 0 0 3.13659 0 7C0 10.8634 3.13659 14 7 14ZM5.03125 6.34375H8.96875C9.33242 6.34375 9.625 6.63633 9.625 7Cnan nan 9.33242 7.65625 8.96875 7.65625H5.03125C4.66758 7.65625 4.375 7.36367 4.375 7Cnan nan 4.66758 6.34375 5.03125 6.34375Z",
    fill: "#F87171"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRow);
export default __webpack_public_path__ + "static/media/removeRow.9ac7abda6b059718f932fdb77870392e.svg";
export { ForwardRef as ReactComponent };